<template>
    <b-tabs card>
      <b-tab title="Profile data">
        <b-card-text>
          <table class="table">
          <tbody>
            <tr>
              <td>Login</td>
              <td>{{account.login}}</td>
            </tr>
            <tr>
              <td>Name</td>
              <td>{{account.firstName}} {{account.lastName}}</td>
            </tr>
            <tr>
              <td>Email</td>
              <td>{{account.email}}</td>
            </tr>
            <tr>
              <td>Language</td>
              <td>{{account.langKey}}</td>
            </tr>
            <tr v-if="account.organization">
              <td>Organization</td>
              <td>{{account.organization.name}}</td>
            </tr>
          </tbody>
          </table>
          <!-- <b-button>Edit</b-button> -->
        </b-card-text>

      </b-tab>

    </b-tabs>
</template>

<script>
export default {
  name: 'UserProfile',
  data() {
    return {

    }
  },
  created: function () {
  //  if( this.account == null || this.account == '' ) {
      this.$store.dispatch('fetchAccount');
  //  }
  },
  computed: {
    account () {
      return this.$store.state.account;
    }
  },
  methods: {

  }

}
</script>
<style scoped>
</style>
